const tokens = {};
const rowVariantGroups = {
    spacing: {
        tiny: {
            itemMarginRight: 4,
        },
        small: {
            itemMarginRight: 8,
        },
        medium: {
            itemMarginRight: 16,
        },
        large: {
            itemMarginRight: 32,
        },
        xlarge: {
            itemMarginRight: 64,
        },
        between: {
            justifyContent: 'space-between',
        },
        around: {
            justifyContent: 'space-around',
        },
    },
    fit: {
        block: {
            flex: 0,
        },
        fill: {
            flex: 1,
        },
    },
};
const colVariantGroups = {
    spacing: {
        tiny: {
            itemMarginRight: 0,
            itemMarginBottom: 4,
        },
        small: {
            itemMarginRight: 0,
            itemMarginBottom: 8,
        },
        medium: {
            itemMarginRight: 0,
            itemMarginBottom: 16,
        },
        large: {
            itemMarginRight: 0,
            itemMarginBottom: 32,
        },
        xlarge: {
            itemMarginRight: 0,
            itemMarginBottom: 64,
        },
        between: {
            justifyContent: 'space-between',
        },
        around: {
            justifyContent: 'space-around',
        },
    },
    fit: {
        block: {
            flex: 0,
        },
        fill: {
            flex: 1,
        },
    },
};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            minWidth: {
                type: 'number',
            },
            minHeight: {
                type: 'number',
            },
            paddingHorizontal: {
                type: 'number',
            },
            paddingVertical: {
                type: 'number',
            },
            borderRadius: {
                type: 'number',
            },
            borderColor: {
                type: 'string',
            },
            borderWidth: {
                type: 'number',
            },
            backgroundColor: {
                type: 'string',
            },
            flexDirection: {
                type: 'string',
            },
            flexWrap: {
                type: 'string',
            },
            justifyContent: {
                type: 'string',
            },
            alignItems: {
                type: 'string',
            },
            itemMarginRight: {
                type: 'number',
            },
            itemMarginBottom: {
                type: 'number',
            },
            flex: {
                type: 'number',
            },
        },
        appearances: {
            row: {
                default: true,
            },
            col: {
                default: false,
            },
            rowReverse: {
                default: false,
            },
            colReverse: {
                default: false,
            },
        },
        variantGroups: {
            spacing: {
                tiny: {
                    default: false,
                },
                small: {
                    default: false,
                },
                medium: {
                    default: false,
                },
                large: {
                    default: false,
                },
                xlarge: {
                    default: false,
                },
                between: {
                    default: false,
                },
                around: {
                    default: false,
                },
            },
            fit: {
                block: {
                    default: false,
                },
                fill: {
                    default: false,
                },
            },
        },
        states: {},
    },
    appearances: {
        row: {
            mapping: {
                flexDirection: 'row',
            },
            variantGroups: rowVariantGroups,
        },
        col: {
            mapping: {
                flexDirection: 'col',
            },
            variantGroups: colVariantGroups,
        },
        rowReverse: {
            mapping: {
                flexDirection: 'row-reverse',
            },
            variantGroups: rowVariantGroups,
        },
        colReverse: {
            mapping: {
                flexDirection: 'column-reverse',
            },
            variantGroups: colVariantGroups,
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNABox.theme.alucio.js.map